var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhite1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 250 100"
    },
    xmlSpace: "preserve",
    viewBox: "2.39 35.22 245.49 41.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000155867579134465914430000010226993546463013029_);}\n\t.st2{fill:url(#SVGID_00000158751147963711871370000004478422317992051369_);}\n\t.st3{fill:url(#SVGID_00000167385242425739941190000008361182307600065953_);}\n\t.st4{fill:url(#SVGID_00000027563289565159328540000017709801564579012782_);}\n\t.st5{fill:url(#SVGID_00000092425437282554220690000010429010964423999676_);}\n\t.st6{fill:url(#SVGID_00000171708403832685202620000003200345632126317232_);}\n\t.st7{fill:url(#SVGID_00000059283662705826949010000018299580689963856813_);}\n\t.st8{fill:url(#SVGID_00000152250771296680456170000014709211152381176750_);}\n\t.st9{fill:url(#SVGID_00000033335794039558227180000008326172201242518693_);}\n\t.st10{fill:url(#SVGID_00000070832184600281330340000012731992382513513404_);}\n\t.st11{fill:url(#SVGID_00000104705440218510000880000008357782957928278175_);}\n\t.st12{fill:url(#SVGID_00000155847025083047449530000009507199999919561892_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.0041,
    y1: 57.1633,
    x2: 54.0041,
    y2: 100.2222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.47,37.87L54.47,37.87c0.04,0.05,0.08,0.1,0.12,0.15C54.54,37.97,54.5,37.92,54.47,37.87z M53.69,37.07      c-0.03-0.03-0.06-0.05-0.09-0.08c0,0-0.01-0.01-0.01-0.01c0.11,0.1,0.22,0.19,0.32,0.3C53.84,37.21,53.77,37.14,53.69,37.07z       M52.87,36.43c0.14,0.09,0.28,0.2,0.41,0.3c-0.01-0.01-0.03-0.02-0.04-0.03C53.12,36.61,53,36.52,52.87,36.43z M53.35,36.78      c0.08,0.07,0.17,0.14,0.25,0.21c-0.1-0.09-0.21-0.18-0.31-0.26C53.3,36.74,53.33,36.76,53.35,36.78z M55.12,38.77      c-0.03-0.05-0.06-0.1-0.09-0.14c-0.03-0.05-0.07-0.1-0.1-0.14c0.08,0.11,0.14,0.21,0.21,0.33      C55.13,38.8,55.13,38.79,55.12,38.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168114875966859764610000004126060683948309899_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.7759,
    y1: 57.1633,
    x2: 29.7759,
    y2: 100.2222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168114875966859764610000004126060683948309899_)"
    },
    d: "M57.16,49      c-0.01,0.65-0.04,1.27-0.06,1.86c-0.01,0.21-0.03,0.41-0.04,0.62c0,0.04-0.01,0.09-0.01,0.13c-0.28,4.31-1.31,8.57-3.03,12.53      c-2.08,4.95-5.34,9.82-10.49,11.92c-2.37,1.03-5.09,1.27-7.54,0.32c-1.08-0.4-2.09-0.95-3.06-1.57      c-0.95-0.62-1.92-1.26-2.76-2.03c-4.21-3.89-7.45-8.68-10.75-13.33c-1.97-2.79-3.77-5.73-6.15-8.18      c-0.13-0.13-0.25-0.24-0.38-0.36c-1.51-1.33-3.87-1.17-5.19,0.35c-0.01,0.01-0.02,0.01-0.03,0.03      c-0.74,0.84-1.21,1.88-1.62,2.92c-1.46,3.68-1.98,7.74-1.42,11.66c0.32,2.48,1.66,6.07,4.75,5.46c2.98-0.58,5.27-2.54,6.86-4.13      c-1.12,1.69-3.2,3.77-3.48,4.06c-0.01,0.01-0.01,0.01-0.02,0.03c-0.01,0-0.01,0-0.01,0v0.01c-0.01,0-0.01,0-0.01,0      c-0.18,0.17-0.36,0.33-0.53,0.48c-1.67,1.4-4.31,3.02-6.58,2.3C2.17,72.8,2.3,66.24,2.44,63.2C2.75,58.74,4,53.9,6.81,50.34      c0.16-0.19,0.33-0.38,0.53-0.54c3-2.48,5.34-0.95,7.79,1.56c2.08,2.17,3.89,4.6,5.7,7c2.39,3.18,4.86,6.33,7.68,9.14      c3.44,3.48,8.03,6.41,13.11,5.36c4.67-1.13,7.8-6.5,9.76-10.56c1.66-3.62,2.68-7.51,3.35-11.44c0.62-3.86,1.23-8.09-0.62-11.72      c-1.73-3.11-4.1-3.98-7.52-3.24c-0.47,0.1-1.04,0.26-1.57,0.41c0.01-0.01,0.03-0.01,0.04-0.02c0.34-0.16,2.1-0.92,3.76-1.05      c0.14-0.01,0.28-0.02,0.41-0.02c0.19,0,0.38,0.01,0.57,0.03c0.24,0.04,0.48,0.08,0.7,0.14c0.13,0.03,0.24,0.06,0.36,0.09      c0.04,0.01,0.08,0.03,0.11,0.04c0.12,0.03,0.23,0.07,0.34,0.11c0.06,0.03,0.11,0.04,0.16,0.06c0.06,0.03,0.11,0.04,0.16,0.07      c0.01,0.01,0.03,0.01,0.04,0.01c0.01,0.01,0.01,0.01,0.01,0.01c0.29,0.13,0.56,0.26,0.82,0.41c0.13,0.07,0.24,0.14,0.36,0.23      c0.13,0.09,0.25,0.18,0.37,0.26c0.04,0.03,0.08,0.06,0.11,0.09c0.09,0.07,0.18,0.14,0.26,0.21c0.03,0.03,0.06,0.05,0.09,0.08      c0.08,0.07,0.15,0.14,0.23,0.21c0.01,0.01,0.03,0.02,0.04,0.03c0.18,0.18,0.35,0.36,0.5,0.55h0.01c0.04,0.05,0.08,0.1,0.12,0.15      l0.11,0.15c0.08,0.1,0.16,0.21,0.23,0.31c0.08,0.11,0.14,0.21,0.21,0.33c0.06,0.1,0.13,0.19,0.18,0.3      c0.08,0.14,0.16,0.29,0.24,0.44c0.03,0.07,0.07,0.13,0.09,0.2c0.03,0.04,0.05,0.09,0.07,0.14c0.01,0.02,0.02,0.04,0.03,0.06      C56.98,42.65,57.21,46.05,57.16,49z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045589068182205197270000015969703098096448418_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.0309,
    y1: 57.1633,
    x2: 55.0309,
    y2: 100.2222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045589068182205197270000015969703098096448418_)"
    },
    d: "M55.12,38.77      c-0.03-0.05-0.06-0.1-0.09-0.14c-0.03-0.05-0.07-0.1-0.1-0.14c0.08,0.11,0.14,0.21,0.21,0.33      C55.13,38.8,55.13,38.79,55.12,38.77z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062155667025747919320000002293451874673025684_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.1111,
    y1: 56.0335,
    x2: 77.1111,
    y2: 78.3915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062155667025747919320000002293451874673025684_)"
    },
    d: "M68.65,58.86c0-1.17,0.22-2.27,0.67-3.3    c0.44-1.03,1.05-1.93,1.81-2.69c0.76-0.76,1.66-1.36,2.69-1.81c1.03-0.44,2.13-0.67,3.3-0.67c1.17,0,2.27,0.22,3.3,0.67    c1.03,0.45,1.93,1.05,2.69,1.81c0.76,0.76,1.36,1.66,1.81,2.69c0.44,1.03,0.67,2.13,0.67,3.3v7.52c0,0.3-0.11,0.56-0.32,0.77    c-0.21,0.21-0.47,0.32-0.77,0.32c-0.3,0-0.56-0.11-0.77-0.32c-0.21-0.21-0.32-0.47-0.32-0.77v-7.52c0-0.87-0.16-1.68-0.49-2.44    c-0.33-0.76-0.78-1.43-1.35-2c-0.57-0.57-1.24-1.02-2-1.35c-0.76-0.33-1.58-0.49-2.44-0.49c-0.87,0-1.68,0.16-2.44,0.49    c-0.76,0.33-1.43,0.78-2,1.35c-0.57,0.57-1.02,1.24-1.35,2c-0.33,0.76-0.49,1.57-0.49,2.44v7.52c0,0.3-0.11,0.56-0.32,0.77    c-0.21,0.21-0.47,0.32-0.77,0.32c-0.3,0-0.56-0.11-0.77-0.32c-0.21-0.21-0.32-0.47-0.32-0.77V58.86z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096765317841036172390000002561957178427786934_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.8911,
    y1: 56.0335,
    x2: 97.8911,
    y2: 78.3915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096765317841036172390000002561957178427786934_)"
    },
    d: "M91.65,60.02    c0.12,0.75,0.36,1.45,0.74,2.09c0.37,0.64,0.84,1.2,1.39,1.67c0.55,0.47,1.18,0.84,1.88,1.11c0.7,0.27,1.44,0.4,2.21,0.4    c0.87,0,1.67-0.16,2.42-0.47c0.75-0.32,1.42-0.76,2-1.32c0.21-0.21,0.47-0.32,0.77-0.32c0.3,0,0.56,0.11,0.77,0.32    c0.21,0.21,0.32,0.47,0.32,0.77c0,0.3-0.11,0.56-0.32,0.77c-0.77,0.87-1.65,1.48-2.62,1.84c-0.97,0.36-2.09,0.54-3.35,0.54    c-1.17,0-2.27-0.21-3.28-0.63c-1.02-0.42-1.91-1.01-2.69-1.76c-0.77-0.75-1.38-1.64-1.83-2.67c-0.45-1.03-0.67-2.15-0.67-3.37    c0-1.17,0.22-2.27,0.65-3.28c0.43-1.02,1.03-1.91,1.79-2.67c0.76-0.76,1.66-1.37,2.7-1.83c1.04-0.46,2.17-0.71,3.39-0.76    c1.12,0,2.18,0.22,3.18,0.67c1,0.45,1.88,1.04,2.65,1.79c0.77,0.75,1.39,1.63,1.84,2.63c0.46,1.01,0.71,2.08,0.75,3.23    c0.05,0.4-0.05,0.7-0.3,0.91c-0.25,0.21-0.51,0.32-0.79,0.32H91.65z M97.87,52.68c-0.77,0-1.5,0.14-2.2,0.4    c-0.69,0.27-1.31,0.63-1.86,1.09c-0.55,0.46-1.01,1-1.37,1.63c-0.36,0.63-0.61,1.31-0.76,2.04h12.4c-0.14-0.73-0.4-1.4-0.77-2.04    c-0.37-0.63-0.84-1.18-1.39-1.63c-0.55-0.46-1.17-0.82-1.86-1.09C99.37,52.81,98.64,52.68,97.87,52.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163774360745273119000000017889965695476023470_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.8877,
    y1: 56.0335,
    x2: 117.8877,
    y2: 78.3915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163774360745273119000000017889965695476023470_)"
    },
    d: "M126,67.15    c-0.23,0.21-0.5,0.32-0.79,0.32c-0.29,0-0.54-0.12-0.76-0.35l-6.57-6.6l-6.57,6.6c-0.21,0.23-0.46,0.35-0.76,0.35    c-0.29,0-0.56-0.11-0.79-0.32c-0.21-0.21-0.32-0.46-0.32-0.75c0-0.29,0.11-0.56,0.32-0.79l6.57-6.64l-6.53-6.64    c-0.21-0.23-0.32-0.5-0.33-0.79c-0.01-0.29,0.09-0.54,0.3-0.75c0.23-0.21,0.5-0.32,0.79-0.33c0.29-0.01,0.54,0.09,0.76,0.3    l6.57,6.67l6.57-6.67c0.21-0.21,0.46-0.31,0.76-0.3c0.29,0.01,0.56,0.12,0.79,0.33c0.21,0.21,0.31,0.46,0.3,0.75    c-0.01,0.29-0.12,0.56-0.33,0.79l-6.57,6.64l6.6,6.64c0.21,0.23,0.32,0.5,0.32,0.79C126.32,66.68,126.21,66.93,126,67.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114055432396644784050000017485404228210718645_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.8896,
    y1: 56.0335,
    x2: 137.8896,
    y2: 78.3915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114055432396644784050000017485404228210718645_)"
    },
    d: "M137.94,50.46c1.12,0,2.2,0.23,3.21,0.68    c1.02,0.46,1.91,1.07,2.69,1.84c0.77,0.77,1.39,1.67,1.84,2.7c0.46,1.03,0.69,2.13,0.69,3.3c0,1.15-0.22,2.23-0.67,3.25    c-0.45,1.02-1.05,1.91-1.81,2.69c-0.76,0.77-1.66,1.38-2.69,1.83c-1.03,0.45-2.14,0.67-3.34,0.67c-1.17,0-2.27-0.21-3.28-0.63    c-1.02-0.42-1.91-1.01-2.69-1.76c-0.77-0.75-1.38-1.64-1.83-2.67c-0.44-1.03-0.67-2.15-0.67-3.37c0-1.17,0.22-2.27,0.65-3.28    c0.43-1.02,1.03-1.91,1.79-2.67c0.76-0.76,1.66-1.37,2.7-1.83C135.59,50.76,136.72,50.51,137.94,50.46z M131.59,59    c0,0.87,0.16,1.68,0.49,2.44c0.33,0.76,0.78,1.43,1.35,2c0.57,0.57,1.24,1.02,2,1.35c0.76,0.33,1.57,0.49,2.44,0.49    c0.87,0,1.69-0.16,2.46-0.49c0.77-0.33,1.45-0.78,2.02-1.35c0.57-0.57,1.02-1.24,1.35-2c0.33-0.76,0.49-1.57,0.49-2.44    c0-0.87-0.16-1.69-0.49-2.46c-0.33-0.77-0.78-1.45-1.35-2.02c-0.57-0.57-1.25-1.02-2.02-1.35c-0.77-0.33-1.59-0.49-2.46-0.49    c-0.87,0-1.68,0.16-2.44,0.49c-0.76,0.33-1.43,0.78-2,1.35c-0.57,0.57-1.02,1.25-1.35,2.02C131.75,57.31,131.59,58.13,131.59,59z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132772930092699337040000018404982762497534093_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.6639,
    y1: 56.0335,
    x2: 158.6639,
    y2: 78.3915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132772930092699337040000018404982762497534093_)"
    },
    d: "M150.2,58.86c0-1.17,0.22-2.27,0.67-3.3    c0.44-1.03,1.05-1.93,1.81-2.69c0.76-0.76,1.66-1.36,2.69-1.81c1.03-0.44,2.13-0.67,3.3-0.67c1.17,0,2.27,0.22,3.3,0.67    c1.03,0.45,1.93,1.05,2.69,1.81c0.76,0.76,1.36,1.66,1.81,2.69c0.44,1.03,0.67,2.13,0.67,3.3v7.52c0,0.3-0.11,0.56-0.32,0.77    c-0.21,0.21-0.47,0.32-0.77,0.32c-0.3,0-0.56-0.11-0.77-0.32c-0.21-0.21-0.32-0.47-0.32-0.77v-7.52c0-0.87-0.16-1.68-0.49-2.44    c-0.33-0.76-0.78-1.43-1.35-2c-0.57-0.57-1.24-1.02-2-1.35c-0.76-0.33-1.58-0.49-2.44-0.49c-0.87,0-1.68,0.16-2.44,0.49    c-0.76,0.33-1.43,0.78-2,1.35c-0.57,0.57-1.02,1.24-1.35,2c-0.33,0.76-0.49,1.57-0.49,2.44v7.52c0,0.3-0.11,0.56-0.32,0.77    c-0.21,0.21-0.47,0.32-0.77,0.32c-0.3,0-0.56-0.11-0.77-0.32c-0.21-0.21-0.32-0.47-0.32-0.77V58.86z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008140505975539005510000015957836996109002671_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.444,
    y1: 56.0335,
    x2: 179.444,
    y2: 78.3915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008140505975539005510000015957836996109002671_)"
    },
    d: "M173.2,60.02    c0.12,0.75,0.36,1.45,0.74,2.09c0.37,0.64,0.84,1.2,1.39,1.67c0.55,0.47,1.18,0.84,1.88,1.11c0.7,0.27,1.44,0.4,2.21,0.4    c0.87,0,1.67-0.16,2.42-0.47c0.75-0.32,1.42-0.76,2-1.32c0.21-0.21,0.47-0.32,0.77-0.32c0.3,0,0.56,0.11,0.77,0.32    c0.21,0.21,0.32,0.47,0.32,0.77c0,0.3-0.11,0.56-0.32,0.77c-0.77,0.87-1.65,1.48-2.62,1.84c-0.97,0.36-2.09,0.54-3.35,0.54    c-1.17,0-2.27-0.21-3.28-0.63c-1.02-0.42-1.91-1.01-2.69-1.76c-0.77-0.75-1.38-1.64-1.83-2.67c-0.45-1.03-0.67-2.15-0.67-3.37    c0-1.17,0.22-2.27,0.65-3.28c0.43-1.02,1.03-1.91,1.79-2.67c0.76-0.76,1.66-1.37,2.7-1.83c1.04-0.46,2.17-0.71,3.39-0.76    c1.12,0,2.18,0.22,3.18,0.67c1,0.45,1.88,1.04,2.65,1.79c0.77,0.75,1.39,1.63,1.84,2.63c0.46,1.01,0.71,2.08,0.75,3.23    c0.05,0.4-0.05,0.7-0.3,0.91c-0.25,0.21-0.51,0.32-0.79,0.32H173.2z M179.42,52.68c-0.77,0-1.5,0.14-2.2,0.4    c-0.69,0.27-1.31,0.63-1.86,1.09c-0.55,0.46-1.01,1-1.37,1.63c-0.36,0.63-0.61,1.31-0.76,2.04h12.4c-0.14-0.73-0.4-1.4-0.77-2.04    c-0.37-0.63-0.84-1.18-1.39-1.63c-0.55-0.46-1.17-0.82-1.86-1.09C180.93,52.81,180.19,52.68,179.42,52.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029741095779661781120000011715906395385233307_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.0964,
    y1: 56.0335,
    x2: 199.0964,
    y2: 78.3915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029741095779661781120000011715906395385233307_)"
    },
    d: "M191.71,45.83c0-0.3,0.11-0.56,0.32-0.77    c0.21-0.21,0.47-0.32,0.77-0.32c0.3,0,0.56,0.11,0.77,0.32c0.21,0.21,0.32,0.47,0.32,0.77v4.5h7.76c0.37,0,0.67,0.11,0.9,0.32    c0.22,0.21,0.33,0.47,0.33,0.77c0,0.3-0.11,0.56-0.33,0.77c-0.22,0.21-0.52,0.32-0.9,0.32h-7.76V59c0,0.87,0.16,1.68,0.49,2.44    c0.33,0.76,0.78,1.43,1.35,2c0.57,0.57,1.24,1.02,2,1.35c0.76,0.33,1.57,0.49,2.44,0.49c0.87,0,1.67-0.16,2.42-0.47    c0.75-0.32,1.4-0.76,1.97-1.32c0.19-0.21,0.43-0.33,0.72-0.37c0.29-0.04,0.57,0.04,0.83,0.23c0.19,0.19,0.3,0.42,0.35,0.7    c0.05,0.28-0.01,0.55-0.18,0.81c-0.77,0.82-1.69,1.46-2.74,1.91c-1.05,0.46-2.18,0.68-3.37,0.68c-1.17,0-2.27-0.22-3.3-0.67    c-1.03-0.44-1.93-1.05-2.69-1.81c-0.76-0.76-1.36-1.66-1.81-2.69c-0.45-1.03-0.67-2.13-0.67-3.3V45.83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095318819008642057740000004734635934470340229_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.7841,
    y1: 56.0335,
    x2: 210.7841,
    y2: 78.3915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095318819008642057740000004734635934470340229_)"
    },
    d: "M209.34,46.63c0-0.4,0.14-0.74,0.42-1.02    c0.28-0.28,0.62-0.42,1.02-0.42c0.4,0,0.74,0.14,1.02,0.42c0.28,0.28,0.42,0.62,0.42,1.02c0,0.4-0.14,0.74-0.42,1.02    c-0.28,0.28-0.62,0.42-1.02,0.42c-0.4,0-0.74-0.14-1.02-0.42C209.48,47.37,209.34,47.03,209.34,46.63z M209.7,51.52    c0-0.3,0.11-0.56,0.32-0.77c0.21-0.21,0.47-0.32,0.77-0.32c0.3,0,0.56,0.11,0.77,0.32c0.21,0.21,0.32,0.47,0.32,0.77v14.86    c0,0.3-0.11,0.56-0.32,0.77c-0.21,0.21-0.47,0.32-0.77,0.32c-0.3,0-0.56-0.11-0.77-0.32c-0.21-0.21-0.32-0.47-0.32-0.77V51.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160873166008538376040000017643148178814030475_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.998,
    y1: 56.0335,
    x2: 222.998,
    y2: 78.3915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160873166008538376040000017643148178814030475_)"
    },
    d: "M228.52,54.4    c-0.59-0.51-1.25-0.93-2-1.25c-0.75-0.32-1.56-0.47-2.42-0.47c-0.87,0-1.68,0.16-2.44,0.49c-0.76,0.33-1.43,0.78-2,1.35    c-0.57,0.57-1.02,1.25-1.35,2.02c-0.33,0.77-0.49,1.59-0.49,2.46c0,0.87,0.16,1.68,0.49,2.44c0.33,0.76,0.78,1.43,1.35,2    c0.57,0.57,1.24,1.02,2,1.35c0.76,0.33,1.57,0.49,2.44,0.49c0.87,0,1.67-0.16,2.42-0.47c0.75-0.32,1.42-0.76,2-1.32    c0.21-0.21,0.47-0.32,0.77-0.32c0.3,0,0.56,0.11,0.77,0.32c0.21,0.21,0.31,0.47,0.3,0.79c-0.01,0.32-0.15,0.6-0.4,0.86    c-0.21,0.21-0.5,0.45-0.86,0.72c-0.36,0.27-0.8,0.52-1.3,0.76c-0.5,0.23-1.07,0.43-1.69,0.58c-0.62,0.15-1.29,0.23-2.02,0.23    c-1.17,0-2.27-0.21-3.28-0.63c-1.02-0.42-1.91-1.01-2.69-1.76c-0.77-0.75-1.38-1.64-1.83-2.67c-0.45-1.03-0.67-2.15-0.67-3.37    c0-1.17,0.22-2.27,0.65-3.28c0.43-1.02,1.03-1.91,1.79-2.67c0.76-0.76,1.66-1.37,2.7-1.83c1.04-0.46,2.17-0.71,3.39-0.76    c0.7,0,1.35,0.09,1.95,0.26c0.6,0.18,1.14,0.39,1.62,0.63c0.48,0.25,0.91,0.51,1.28,0.79c0.37,0.28,0.68,0.53,0.91,0.74    c0.14,0.12,0.26,0.33,0.37,0.65c0.11,0.32,0.03,0.6-0.23,0.86c-0.21,0.21-0.47,0.32-0.77,0.32    C228.99,54.71,228.73,54.61,228.52,54.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169523332619907460290000008679272622971815325_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.0235,
    y1: 56.0335,
    x2: 241.0235,
    y2: 78.3915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169523332619907460290000008679272622971815325_)"
    },
    d: "M234.53,66.37c0-0.3,0.11-0.56,0.32-0.77    c0.21-0.21,0.47-0.32,0.77-0.32h7.59c0.68,0,1.26-0.25,1.76-0.74c0.49-0.49,0.74-1.08,0.74-1.76c0-0.68-0.25-1.26-0.74-1.76    c-0.49-0.49-1.08-0.74-1.76-0.74h-4.11c-0.68,0-1.32-0.13-1.91-0.39c-0.6-0.26-1.12-0.61-1.56-1.05c-0.45-0.44-0.8-0.97-1.05-1.56    c-0.26-0.6-0.39-1.23-0.39-1.91c0-0.68,0.13-1.32,0.39-1.93c0.26-0.61,0.61-1.14,1.05-1.58c0.44-0.44,0.97-0.8,1.56-1.05    c0.6-0.26,1.23-0.39,1.91-0.39h7.16c0.3,0,0.56,0.11,0.77,0.32c0.21,0.21,0.32,0.47,0.32,0.77c0,0.3-0.11,0.56-0.32,0.77    c-0.21,0.21-0.47,0.32-0.77,0.32h-7.16c-0.75,0.02-1.39,0.3-1.93,0.84c-0.54,0.54-0.81,1.18-0.81,1.93c0,0.75,0.27,1.39,0.81,1.93    c0.54,0.54,1.18,0.81,1.93,0.81h4.11c0.63,0,1.23,0.12,1.81,0.37c0.57,0.25,1.07,0.58,1.49,1s0.75,0.92,1,1.49    c0.25,0.57,0.37,1.18,0.37,1.81c0,0.63-0.12,1.24-0.37,1.81c-0.25,0.57-0.58,1.07-1,1.49s-0.92,0.76-1.49,1    c-0.57,0.25-1.18,0.37-1.81,0.37h-7.59c-0.3,0-0.56-0.11-0.77-0.32C234.63,66.93,234.53,66.68,234.53,66.37z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite1);
export default __webpack_public_path__ + "static/media/white-1.19576fa94c52aea73b9687e0573cd126.svg";
export { ForwardRef as ReactComponent };